export const SUPPLIER_CONFIG = [
  {
    key: 'ignorePrices',
    label: 'Ignore prices',
    tooltip: 'Rule for grabber to finish grabbing even if supplier missing or giving an error on pull the prices'
  },
  {
    key: 'isDecorator',
    label: 'Is decorator',
    tooltip: 'This supplier is a contract decorator which has blank items shipped to it.'
  },
  {
    key: 'isActive',
    label: 'Is Active'
  },
  {
    key: 'hideMPowerSKU',
    label: 'Hide MPower SKU in part dropdown',
    tooltip: 'If checked MPower product part id will NOT be displayed to customers under part list.'
  },
  {
    key: 'hidePartSpecs',
    label: 'Hide part specification data in part dropdown',
    tooltip:
      'Don’t display part specification data in part dropdown.  Some products use this data to differentiate products to customers.  For example flash drives will use specification data to specify memory capacity.'
  },
  {
    key: 'hidePartDescription',
    label: 'Hide part description data in part dropdown',
    tooltip: 'Don’t display part description data in part dropdown.'
  },
  {
    key: 'hidePartColor',
    label: 'Hide part color data in part dropdown',
    tooltip: 'Don’t display part color data in part dropdown.'
  }
];

export function stateRequired(data) {
  return ['US', 'CA', 'AU', 'BR'].includes(data.country);
}
